<template>
  <div>

    <div v-for="(item, index) in registerColumns">

      <div v-if="item.field !== 'id' && item.field !== 'active'">
        <b-form-group
            class="mb-2"
            :id="'formGroup_' + index"
            :label="item.label"
            :label-for="'input_' + index"
            description=""
        >
          <template v-if="item.type === 'date'">
            <b-col lg="4" class="p-0">
            <VueCtkDateTimePicker :id="'activeFrom'" format="YYYY-MM-DDTHH:mm:ss.SS"
                                  :label="item.label"
                                  :locale="$t('text.globals.datePickerLocale')"
                                  :noLabel="true"
                                  :custom-shortcuts="$t('text.globals.customDatePickerShortcuts')"
                                  :range="false"
                                  :auto-close="true"
                                  formatted="DD.MM.YYYY"
                                  v-model="registerEntry[item.field]"
                                  :max-date="item.field === 'activeFrom' && registerEntry['activeTo'] ? moment(registerEntry['activeTo']).startOf('day').subtract(1, 'days').format() : ''"
                                  :min-date="item.field === 'activeTo' && registerEntry['activeFrom'] ? moment(registerEntry['activeFrom']).startOf('day').add(1, 'days').format() : ''"
                                  :no-button-now="true"
                                  :only-date="true"
                                  :class="{'is-invalid': errorObject[item.field]}"
                                  :required="item.field === 'activeFrom'"
                                  @input="validateDescriptionEdit(item)"
                                  :button-now-translation="$t('text.globals.now')"
            />

              <div
                  class="invalid-feedback"
                  v-if="errorObject[item.field]"
                  style="font-size: 1rem"
              >
                {{ $t("text.documentDetailsEdit.fieldShouldNotBeEmpty") }}
              </div>

            </b-col>
          </template>
          <template v-else>

            <b-form-input
                v-if="item.field != 'active'"
                :id="'input_' + index"
                :type="item.type"
                :step="item.type === 'number' ? 1 : null"
                @keydown="(evt) => ['e', 'E', '+', '-'].includes(evt.key) && item.type === 'number' && evt.preventDefault()"
                v-model="registerEntry[item.field]"
                :required="checkIfRequired(item)"
                :placeholder="'vnesi ' +  item.label"
                :class="{'is-invalid': errorObject[item.field]}"
                @input="validateDescriptionEdit(item)"
            ></b-form-input>
            <div
                class="invalid-feedback"
                v-if="errorObject[item.field]"
                style="font-size: 1rem"
            >
              {{ $t("text.documentDetailsEdit.fieldShouldNotBeEmpty") }}
            </div>


<!--            <b-form-checkbox v-if="item.field == 'active'" v-model="registerEntry[item.field]" :id="'input_' + index"-->
<!--                             class="position-relative"><span class="position-absolute" style="top: -6px"> DA</span>-->
<!--            </b-form-checkbox>-->
          </template>
        </b-form-group>
      </div>
    </div>

    <div v-if="registerName === 'UPORABNIKI VPISNIKOV' || registerName === 'VRSTA DOKUMENTA'">
      <div class="form-group">
        <label for="povezaniSistemi2">{{$t('text.classificationPlanMetadata.connectedSystems')}}</label>

        <a class="btn btn-sm btn-link float-right text-info mt-2" @click="selectAllConnectedSystems"
           v-if="registerEntry.connectedSystems && povezaniSistemi && registerEntry.connectedSystems.length < povezaniSistemi.length">{{$t('text.classificationPlanEntry.registryModal.selectAll')}}</a>
        <a class="btn btn-sm btn-link float-right text-info mt-2" @click="deselectAllConnectedSystems"
           v-if="registerEntry.connectedSystems && povezaniSistemi && registerEntry.connectedSystems.length >= povezaniSistemi.length">Odstrani vse</a>

        <v-select
            class="form-control"
            id="povezaniSistemi2"
            name="povezaniSistemi2"
            label="description"
            :options="povezaniSistemi"
            :reduce="item => item.id"
            v-model="registerEntry.connectedSystems"
            :multiple="registerName === 'VRSTA DOKUMENTA' ? true : false"
        >
          <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
        </v-select>
      </div>
    </div>

  </div>

</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Loading from "vue-loading-overlay";

export default {
  name: "RegisterEntry",
  components: {
    vSelect
  },
  props: [
    'registerColumns',
    'registerName'
  ],
  watch: {
    "registerEntry": function (val) {
      console.log("val", val);
      if (val) {
        this.$emit('crudRegisterEntry', val)
      }
    }
  },
  data() {
    return {
      registerEntry: {
        connectedSystems: []
      },
      evipId: null,
      povezaniSistemi: [],
      selectedPovezaniSistemi: null,
      errorObject: {},
    }
  },
  async mounted() {
    const _this = this;

    let p1 = _this.$store.dispatch("retrieveAllDropdownOptions");

    Promise.all([p1]).then((values) => {
      this.povezaniSistemi = this.$store.getters.getConnectedSystemsOptions.filter((item) => item.ehramba);
    });

  },
  methods: {
    validateDescriptionEdit(item) {
      const _this = this;

      // activeTo should not be validated
      if(item.field === 'activeTo') {
        return;
      }

      // if(_this.registerName === 'VRSTA DOKUMENTA') {
      //   _this.errorObject.description = true;
      //   _this.errorObject.externalEvipId = true;
      //   _this.errorObject.externalSuvpId = true;
      //   _this.errorObject.activeFrom = true;
      // }
      let value = "";
      if(item.type === 'number') {
        this.registerEntry[item.field] = this.registerEntry[item.field] ? this.registerEntry[item.field].toString().replace(/[^\d]/g, '') : null;
        value = this.registerEntry[item.field];
      } else {
        value = this.registerEntry[item.field] ? this.registerEntry[item.field].trim() : this.registerEntry[item.field];
      }

      if (value && value.length > 0) {
        delete this.errorObject[item.field];

        if(item.field === 'externalSuvpId') {
          delete this.errorObject['externalEvipId'];
        } else if(item.field === 'externalEvipId') {
          delete this.errorObject['externalSuvpId'];
        }

      } else {
        if((item.field === 'externalSuvpId' && this.registerEntry['externalEvipId'] !== null && this.registerEntry['externalEvipId'] !== '') || (item.field === 'externalEvipId' && this.registerEntry['externalSuvpId'] !== null && this.registerEntry['externalSuvpId'] !== '')) {
          delete this.errorObject['externalSuvpId'];
          delete this.errorObject['externalEvipId'];
        } else {
          this.errorObject[item.field] = true;
        }
      }

      _this.errorObject = _.omit(_this.errorObject, ['id', 'active']);
      this.$forceUpdate();
      this.$emit('addNewItemFormValidation', this.errorObject)
    },

    selectAllConnectedSystems() {
      const _this = this;
      _this.registerEntry.connectedSystems = _this.povezaniSistemi.map(val => val.id);
    },
    deselectAllConnectedSystems() {
      const _this = this;
      _this.registerEntry.connectedSystems = [];
    },
    checkIfRequired(item) {
      if(this.registerName === 'VRSTA DOKUMENTA' && item.field === 'externalSuvpId') {
        if(this.registerEntry['externalEvipId']) {
          return false;
        } else {
          return true;
        }
      }else if(this.registerName === 'VRSTA DOKUMENTA' && item.field === 'externalEvipId') {
        if(this.registerEntry['externalSuvpId']) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
      this.$forceUpdate();
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RegisterEntry.vue